import React from "react";
import { Form, Input, Select, Radio, Checkbox, Row, Col } from "antd";
const { Option } = Select;

const QA_EditQuestion = ({ editingQuestion, setEditingQuestion }) => {
  const renderOptions = (optionType, options, correctAnswers) => {
    switch (optionType) {
      case "radio":
        return (
          <Radio.Group
            value={correctAnswers[0]} // Set the selected radio button
            onChange={(e) => {
              setEditingQuestion({
                ...editingQuestion,
                correct_answers: [e.target.value], // Update the correct answers
              });
            }}
          >
            {options.map((option) => (
              <Radio key={option} value={option}>
                {option}
              </Radio>
            ))}
          </Radio.Group>
        );
      case "checkbox":
        return (
          <Checkbox.Group
            value={correctAnswers} // Set the selected checkboxes
            onChange={(checkedValues) => {
              setEditingQuestion({
                ...editingQuestion,
                correct_answers: checkedValues, // Update the correct answers
              });
            }}
          >
            {options.map((option) => (
              <Checkbox key={option} value={option}>
                {option}
              </Checkbox>
            ))}
          </Checkbox.Group>
        );
      case "description":
        return (
          <Input.TextArea
            placeholder="Enter description here"
            rows={4}
            onChange={(e) =>
              setEditingQuestion({
                ...editingQuestion,
                description: e.target.value,
              })
            }
            value={editingQuestion?.description}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Form layout="vertical">
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item label="Question Title">
            <Input
              value={editingQuestion?.question_title}
              onChange={(e) =>
                setEditingQuestion({
                  ...editingQuestion,
                  question_title: e.target.value,
                })
              }
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Questions">
            <Input.TextArea
              rows={4}
              value={editingQuestion?.question}
              onChange={(e) =>
                setEditingQuestion({
                  ...editingQuestion,
                  question: e.target.value,
                })
              }
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label="Section Name">
            <Input
              value={editingQuestion?.section_name}
              onChange={(e) =>
                setEditingQuestion({
                  ...editingQuestion,
                  section_name: e.target.value,
                })
              }
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Serial Number">
            <Input
              type="text"
              value={editingQuestion?.serial_number}
              onChange={(e) => {
                const value = e.target.value;
                const isValid = /^(\d*\.?\d{0,2})?$/.test(value);
                if (isValid) {
                  setEditingQuestion({
                    ...editingQuestion,
                    serial_number: value === "" ? "" : value,
                  });
                }
              }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label="Main Parameter">
            <Input
              value={editingQuestion?.main_parameter}
              onChange={(e) =>
                setEditingQuestion({
                  ...editingQuestion,
                  main_parameter: e.target.value,
                })
              }
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Answer Options">
            {renderOptions(
              editingQuestion?.option_type,
              editingQuestion?.answer_options || [],
              editingQuestion?.correct_answers || []
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label="Question Score">
            <Input
              type="text"
              value={editingQuestion?.question_score}
              onChange={(e) => {
                const value = e.target.value;
                const isValid = /^[0-9]*$/.test(value) || value === "";
                if (isValid) {
                  setEditingQuestion({
                    ...editingQuestion,
                    question_score: Number(value),
                  });
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Is Mandatory?">
            <Select
              value={editingQuestion?.is_mandatory}
              onChange={(value) =>
                setEditingQuestion({
                  ...editingQuestion,
                  is_mandatory: value,
                })
              }
            >
              <Option value="Yes">Yes</Option>
              <Option value="No">No</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label="Options Type">
            <Select
              value={editingQuestion?.option_type}
              onChange={(value) =>
                setEditingQuestion({
                  ...editingQuestion,
                  option_type: value,
                })
              }
            >
              <Option value="radio">Radio</Option>
              <Option value="checkbox">Checkbox</Option>
              <Option value="description">Description</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Parameter Type">
            <Input
              value={editingQuestion?.parameter_type}
              onChange={(e) =>
                setEditingQuestion({
                  ...editingQuestion,
                  parameter_type: e.target.value,
                })
              }
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Section">
            <Input
              type="text"
              value={editingQuestion?.section}
              onChange={(e) => {
                const value = e.target.value;
                const isValid = /^[0-9.]*$/.test(value) || value === "";
                if (isValid) {
                  setEditingQuestion({
                    ...editingQuestion,
                    section: value,
                  });
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Is Multiple Select Option?">
            <Select
              value={editingQuestion?.is_multiple_select_option}
              onChange={(value) =>
                setEditingQuestion({
                  ...editingQuestion,
                  is_multiple_select_option: value,
                })
              }
            >
              <Option value="Yes">Yes</Option>
              <Option value="No">No</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label="Is Critical Question ?">
            <Select
              value={editingQuestion?.is_critical_question}
              onChange={(value) =>
                setEditingQuestion({
                  ...editingQuestion,
                  is_critical_question: value,
                })
              }
            >
              <Option value="Yes">Yes</Option>
              <Option value="No">No</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Correct Answers (comma separated)">
            <Input
              value={editingQuestion?.correct_answers}
              onChange={(e) => {
                const value = e.target.value;
                setEditingQuestion({
                  ...editingQuestion,
                  correct_answers: value,
                });
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default QA_EditQuestion;
